import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { TrendingUp, TrendingDown } from "lucide-react";

const formatCurrency = (value) => {
  if (value === undefined || value === null) return "0 €";
  if (value === 0) return "0 €";
  if (Math.abs(value) >= 1000000) {
    return `${(value / 1000000).toFixed(1)}M €`;
  }
  if (Math.abs(value) >= 1000) {
    return `${(value / 1000).toFixed(0)}k €`;
  }
  return `${value.toLocaleString("it-IT", { maximumFractionDigits: 0 })} €`;
};

export function BudgetKPICards({ totali, activeTab }) {
  const tipoPositivo = activeTab === "economico" ? "ricavo" : "entrata";
  
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
      <Card className="bg-gradient-to-br from-green-50 to-green-100/50 border-green-200">
        <CardHeader className="pb-2">
          <CardTitle className="text-sm text-green-700">
            Totale {activeTab === "economico" ? "Ricavi" : "Entrate"}
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex items-center gap-2">
            <TrendingUp className="h-5 w-5 text-green-600" />
            <span className="text-2xl font-bold text-green-700">
              {formatCurrency(totali.entrate)}
            </span>
          </div>
        </CardContent>
      </Card>

      <Card className="bg-gradient-to-br from-red-50 to-red-100/50 border-red-200">
        <CardHeader className="pb-2">
          <CardTitle className="text-sm text-red-700">
            Totale {activeTab === "economico" ? "Costi" : "Uscite"}
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex items-center gap-2">
            <TrendingDown className="h-5 w-5 text-red-600" />
            <span className="text-2xl font-bold text-red-700">
              {formatCurrency(totali.uscite)}
            </span>
          </div>
        </CardContent>
      </Card>

      <Card className={`bg-gradient-to-br ${totali.saldo >= 0 ? 'from-blue-50 to-blue-100/50 border-blue-200' : 'from-orange-50 to-orange-100/50 border-orange-200'}`}>
        <CardHeader className="pb-2">
          <CardTitle className={`text-sm ${totali.saldo >= 0 ? 'text-blue-700' : 'text-orange-700'}`}>
            {activeTab === "economico" ? "Risultato" : "Saldo Cassa"}
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex items-center gap-2">
            {totali.saldo >= 0 ? (
              <TrendingUp className="h-5 w-5 text-blue-600" />
            ) : (
              <TrendingDown className="h-5 w-5 text-orange-600" />
            )}
            <span className={`text-2xl font-bold ${totali.saldo >= 0 ? 'text-blue-700' : 'text-orange-700'}`}>
              {formatCurrency(totali.saldo)}
            </span>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
